import gql from 'graphql-tag';

import {
  MatchesAlbumFolderChildrenDetails,
  MatchesAlbumFolderDetails,
} from '../fragments/album-folder';

export const AlbumFolderForJoinTypeCheck = gql`
  query AlbumFolderForJoinTypeCheck($id: RecordID!) {
    albumFolder(id: $id) {
      id
      join_type
      root {
        id
        join_type
      }
    }
  }
`;

export const AlbumFolderForMatches = gql`
  query AlbumFolderForMatches(
    $id: RecordID!
    $exclude_albums_with_memberships: Boolean = false
  ) {
    albumFolder(id: $id) {
      ...MatchesAlbumFolderDetails
      ...MatchesAlbumFolderChildrenDetails
      root {
        ...MatchesAlbumFolderDetails
      }
    }
  }
  ${MatchesAlbumFolderDetails}
  ${MatchesAlbumFolderChildrenDetails}
`;
